import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri } from "../../utilities/apiManager";

const initialState = {
  countries: [],
  selectedCountry: null,
  isLoading: false,
  error: null,
};

export const fetchCountries = createAsyncThunk(
  "countries/fetchCountries",
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth?.accessToken;
      const { data } = await axios.get(`${apiUri}/static/countries`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": "Bearer " + token,
          "Accept-Language": document.documentElement.lang || "en",
        },
      });
      return thunkAPI.fulfillWithValue(data.data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.countries = payload;
        state.error = null;
      })
      .addCase(fetchCountries.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message || "Failed to fetch countries.";
      });
  },
});

export const { setSelectedCountry } = countriesSlice.actions;
export default countriesSlice.reducer;
